import * as React from "react";
import { Phone, Clock, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
export default function OpeningHours() {
  const serviceAreas = [{
    name: "Punta Gorda",
    zone: "Primary Zone",
    url: "/PuntaGordaPestControlPage"
  }, {
    name: "Port Charlotte",
    zone: "Primary Zone",
    url: "/PortCharlottePestControlPage"
  }, {
    name: "Cape Coral & Burnt Store",
    zone: "Daily Routes",
    url: "/CapeCoralPestControlPage"
  }, {
    name: "North Fort Myers",
    zone: "Extended Service",
    url: "/NorthFortMyersPestControlPage"
  }];
  return <section data-section-id="239826" id="our-local-footprint" className="bg-background text-foreground relative overflow-hidden py-20 border-y border-primary/20">
      {}
      <div className="absolute inset-0 opacity-10 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/southwest_florida_topographic_overlay.png)] bg-cover bg-center mix-blend-multiply pointer-events-none"></div>
      
      {}
      <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-background/70 pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {}
          <div className="flex flex-col items-center lg:items-start space-y-8 text-center lg:text-left">
            <div className="flex items-center gap-6 bg-primary/10 p-4 pr-8 rounded-lg border border-primary/30 backdrop-blur-sm">
              <div className="relative flex items-center justify-center size-12 rounded-lg bg-primary/20">
                {}
                <span className="relative inline-flex rounded-lg h-5 w-5 bg-primary shadow-lg shadow-primary/50"></span>
              </div>
              <span className="text-4xl md:text-5xl font-bold tracking-widest text-primary uppercase font-default">
                Active
              </span>
            </div>
            
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl font-bold font-default leading-tight text-primary">
                Serving Southwest Florida <br className="hidden md:block" />
                <span className="text-foreground">With Local Expertise</span>
              </h2>
              <p className="text-lg text-foreground font-serif max-w-md mx-auto lg:mx-0">We are conveniently located and available to promptly address your pest issues</p>
            </div>
          </div>

          {}
          <Card className="bg-card border-primary/20 backdrop-blur-md">
            <CardContent className="p-8 md:p-10 flex flex-col space-y-10">
              
              {}
              <div className="space-y-6">
                <h3 className="text-2xl font-bold font-default flex items-center gap-3 text-foreground border-b-2 border-primary pb-4">
                  <Clock className="size-6 text-primary" />
                  Service Areas
                </h3>
                
                <div className="flex flex-col space-y-2">
                  {serviceAreas.map((area, i) => <Link key={i} data-index={i} to={area.url} className="group flex items-center justify-between p-4 border-b border-border/30 hover:bg-primary/5 transition-colors">
                      <div className="flex items-center gap-3">
                        <MapPin className="size-5 text-primary group-hover:scale-110 transition-transform" />
                        <span className="font-bold text-lg text-foreground font-default">{area.name}</span>
                      </div>
                      
                    </Link>)}
                </div>
              </div>

              <div className="h-px w-full bg-gradient-to-r from-transparent via-primary to-transparent"></div>

              {}
              <div className="flex flex-col items-center lg:items-start space-y-3 pt-2">
                <span className="text-sm text-foreground uppercase tracking-widest font-bold font-default">
                  Schedule Your Free Inspection
                </span>
                <Link to="tel:941-888-0485" className="text-5xl md:text-[3rem] font-bold font-default text-primary hover:text-primary/80 transition-colors flex items-center gap-4 group">
                  <div className="p-3 rounded-lg bg-primary/10 group-hover:bg-primary/20 transition-colors">
                    <Phone className="size-8 md:size-10" />
                  </div>
                  Call Now
                </Link>
              </div>

            </CardContent>
          </Card>

        </div>
      </div>
    </section>;
}